import React, { useEffect, useState } from 'react';
import { Brand } from '../components/common/Brand';
import { TwoFactorChallenge } from '../components/auth/TwoFactorChallenge';
import { Seo } from '../components/Seo';

// Landing spot for the backend-mediated OAuth flow. The auth server redirects
// here with `#token=<jwt>&email=...`, or — when the account has 2FA on —
// `#mfa=<mfa_token>&email=...` (then we show the code step), or `#error=...`.
export const OAuthCallback: React.FC = () => {
  const [msg, setMsg] = useState('Signing you in…');
  const [mfaToken, setMfaToken] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = params.get('token');
    const mfa = params.get('mfa');
    const err = params.get('error');
    if (mfa) {
      window.history.replaceState(null, '', '/oauth'); // drop the mfa token from the URL
      setMfaToken(mfa);
    } else if (token) {
      localStorage.setItem('access_token', token);
      window.history.replaceState(null, '', '/oauth'); // drop the token from the URL
      window.location.replace('/dashboard');
    } else {
      setMsg('Sign-in was cancelled or failed. Redirecting…');
      window.location.replace('/login?oauth=' + encodeURIComponent(err || 'failed'));
    }
  }, []);

  if (mfaToken) {
    // completeLogin2fa stores the JWT; a full navigation lets AuthContext re-read it.
    return <TwoFactorChallenge mfaToken={mfaToken} onDone={() => window.location.replace('/dashboard')} />;
  }

  return (
    <div className="auth auth-center">
      <Seo title="Signing you in — Local Area Cloud" description="Completing sign-in to your Local Area Cloud account." path="/oauth" noindex />
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div className="auth-brand"><Brand variant="full" height={64} /></div>
        <h1 className="auth-title">Just a moment</h1>
        <p className="auth-sub">{msg}</p>
      </div>
    </div>
  );
};
